import { Controller } from "@hotwired/stimulus";
import dayjs from "dayjs";

export default class DateOffsetController extends Controller {
  static targets = ["dateField", "daysUntilNextTime", "nextDateField"];
  static values = { daysUntilNextTime: Number };

  declare readonly dateFieldTarget: HTMLInputElement;
  declare readonly nextDateFieldTargets: HTMLInputElement[];
  declare readonly daysUntilNextTimeValue: number;

  update(): void {
    this.nextDateFieldTargets.forEach((target: HTMLInputElement) => {
      target.value = dayjs(this.dateFieldTarget.value).add(this.daysUntilNextTimeValue, "days").format("YYYY/MM/DD");
    });
  }
}
